<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'AgentStatisticsShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'agent_statistics_finance', tabName: '销售额统计' },
        { routeName: 'agent_statistics_order', tabName: '订单量统计' },
        { routeName: 'agent_statistics_card', tabName: '用卡量统计' }
      ]
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.activeKey = this.$route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
